import { bankApi } from '@/api';
export default {
    async requestBankDeposit({ serialNumber, depositBaromoney }) {
        const data = {
            serialNumber,
            depositBaromoney,
        };
        const response = await bankApi.postBankDeposit(data);
        return response.data;
    },
    async getVirtualBank() {
        const response = await bankApi.getVirtualBank();
        return response.data;
    },
};
